import { AppLinkRedirectErrorMessage } from '../constants/app-link-redirect.constants';
import {
  AppAction,
  Application
} from '../apis/eols-app-link/eols-app-link.constants';
import { RecommendationContentTypeDto } from '../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { PageContextType } from '../utilities/sherpath-ai-context.utilities';

export enum NewRelicAnalyticsAction {
  LOGIN_LAUNCH = 'LOGIN_LAUNCH',
  APP_LINK_LAUNCH = 'APP_LINK_LAUNCH',
  APP_LINK_ERROR = 'APP_LINK_ERROR',
  APP_LINK_OUT = 'APP_LINK_OUT',
  API_ERROR = 'API_ERROR',
  JS_ERROR = 'JS_ERROR',
  INSTRUCTOR_SWITCHED_STUDENT = 'INSTRUCTOR_SWITCHED_STUDENT',
  IRRELEVANT_RECOMMENDATION_REPORTED = 'IRRELEVANT_RECOMMENDATION_REPORTED',
  ATTEMPT_STARTED = 'ATTEMPT_STARTED',
  ATTEMPT_RESUMED = 'ATTEMPT_RESUMED',
  QUIZ_SESSION_STARTED = 'QUIZ_SESSION_STARTED',
  QUIZ_RESULTS_VIEWED = 'QUIZ_RESULTS_VIEWED',
  RECOMMENDATION_SKIPPED = 'RECOMMENDATION_SKIPPED',
  NEXT_RECOMMENDATION_LAUNCHED = 'NEXT_RECOMMENDATION_LAUNCHED',
  RECOMMENDATION_VIEW_TOGGLED = 'RECOMMENDATION_VIEW_TOGGLED',
  ACTIVITY_TAB_VIEWED = 'ACTIVITY_TAB_VIEWED',
  TAB_SWITCHED = 'TAB_SWITCHED',
  NEXT_RECOMMENDATION_BUTTON_CLICKED = 'NEXT_RECOMMENDATION_BUTTON_CLICKED',
  BACK_TO_PLP_CLICKED = 'BACK_TO_PLP_CLICKED',
  CONTENT_COMPLETED = 'CONTENT_COMPLETED',
  EMAIL_BUTTON_CLICKED = 'EMAIL_BUTTON_CLICKED',
  VIEW_ACTIVITIES_CLICKED = 'VIEW_ACTIVITIES_CLICKED',
  CONTENT_VIEW_CLICKED = 'CONTENT_VIEW_CLICKED',
  VIEW_NEXT_RECOMMENDATION_CLICKED = 'VIEW_NEXT_RECOMMENDATION_CLICKED',
  ACTIVITY_DETAILS_TOGGLED = 'ACTIVITY_DETAILS_TOGGLED',
  SHERPATH_AI_TOGGLED = 'SHERPATH_AI_TOGGLED',
  SHERPATH_AI_OPEN_IN_NEW_TAB_CLICKED = 'SHERPATH_AI_OPEN_IN_NEW_TAB_CLICKED',
  EBOOK_CFI_LINK_RESULT = 'EBOOK_CFI_LINK_RESULT'
}

export type NewRelicAnalyticsActionProps = {
  action: NewRelicAnalyticsAction.LOGIN_LAUNCH;
  props: null;
} | {
  action: NewRelicAnalyticsAction.API_ERROR;
  props: {
    status: string;
    action: string;
    url: string;
    method: string;
  };
} | {
  action: NewRelicAnalyticsAction.APP_LINK_ERROR;
  props: {
    type: AppLinkRedirectErrorMessage;
    status: string;
    url: string;
    method: string;
  };
} | {
  action: NewRelicAnalyticsAction.APP_LINK_OUT
    | NewRelicAnalyticsAction.APP_LINK_LAUNCH;
  props: {
    linkType: AppAction;
    srcApp: Application;
    targetApp: Application;
  };
} | {
  action: NewRelicAnalyticsAction.JS_ERROR;
  props: {
    errorName: string;
    errorMessage: string;
    errorStack: string;
  };
} | {
  action: NewRelicAnalyticsAction.INSTRUCTOR_SWITCHED_STUDENT;
  props: {
    studentUserId: number;
    studentStudyEolsAssessmentId: number;
    remediationAssignmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.IRRELEVANT_RECOMMENDATION_REPORTED;
  props: {
    recommendationId: number;
    studentStudyEolsAssessmentId: number;
    remediationAssignmentId: number;
    contentType: RecommendationContentTypeDto;
    skipExplanation: string;
  };
} | {
  action: NewRelicAnalyticsAction.ATTEMPT_STARTED;
  props: {
    recommendationId: number;
    recommendationAttemptId: number;
    contentType: RecommendationContentTypeDto;
    remediationAssignmentId: number;
    assessmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.ATTEMPT_RESUMED;
  props: {
    recommendationId: number;
    recommendationAttemptId: number;
    contentType: RecommendationContentTypeDto;
    remediationAssignmentId: number;
    assessmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.QUIZ_SESSION_STARTED;
  props: {
    recommendationId: number;
    recommendationAttemptId: number;
    quizSessionId: number;
    totalQuestions: number;
    remediationAssignmentId: number;
    assessmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.QUIZ_RESULTS_VIEWED;
  props: {
    recommendationId?: number;
    recommendationAttemptId?: number;
    remediationAssignmentId?: number;
    assessmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.RECOMMENDATION_SKIPPED;
  props: {
    recommendationId?: number;
    contentType?: RecommendationContentTypeDto;
    remediationAssignmentId?: number;
    assessmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.NEXT_RECOMMENDATION_LAUNCHED;
  props: {
    recommendationId: number;
    contentType: RecommendationContentTypeDto;
    remediationAssignmentId: number;
    assessmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.RECOMMENDATION_VIEW_TOGGLED;
  props: {
    viewType: 'showAll' | 'showMostRelevant';
    remediationAssignmentId: number;
    assessmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.ACTIVITY_TAB_VIEWED;
  props: {
    studentUserId: number;
    studentStudyEolsAssessmentId: number;
    remediationAssignmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.TAB_SWITCHED;
  props: {
    targetTab: string;
    studentUserId?: number;
    studentStudyEolsAssessmentId?: number;
    remediationAssignmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.NEXT_RECOMMENDATION_BUTTON_CLICKED;
  props: {
    recommendationId?: number;
    contentType?: RecommendationContentTypeDto;
    remediationAssignmentId?: number;
    assessmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.BACK_TO_PLP_CLICKED;
  props: {
    recommendationId?: number;
    contentType?: RecommendationContentTypeDto;
    remediationAssignmentId?: number;
    assessmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.CONTENT_COMPLETED;
  props: {
    recommendationId: number;
    recommendationAttemptId: number;
    contentType: RecommendationContentTypeDto;
    score?: number;
    passed: boolean;
    remediationAssignmentId: number;
    assessmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.EMAIL_BUTTON_CLICKED;
  props: {
    studentUserId: number;
    studentStudyEolsAssessmentId: number;
    remediationAssignmentId: number;
  };
} | {
  action: NewRelicAnalyticsAction.VIEW_ACTIVITIES_CLICKED;
  props: {
    activityType: string;
    studentUserId?: number;
    studentStudyEolsAssessmentId?: number;
    remediationAssignmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.CONTENT_VIEW_CLICKED;
  props: {
    recommendationId: number;
    recommendationAttemptId?: number;
    contentType: RecommendationContentTypeDto;
    viewContext: 'activityLog' | 'activityTypeModal' | 'studentDetail';
    studentUserId?: number;
    remediationAssignmentId?: number;
    assessmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.VIEW_NEXT_RECOMMENDATION_CLICKED;
  props: {
    recommendationId?: number;
    contentType?: RecommendationContentTypeDto;
    remediationAssignmentId?: number;
    assessmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.ACTIVITY_DETAILS_TOGGLED;
  props: {
    targetState: 'expanded' | 'collapsed';
    recommendationId?: number;
    contentType?: RecommendationContentTypeDto;
    remediationAssignmentId?: number;
    assessmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.SHERPATH_AI_TOGGLED;
  props: {
    targetState: 'opened' | 'closed';
    pageContextType: PageContextType;
    remediationAssignmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.SHERPATH_AI_OPEN_IN_NEW_TAB_CLICKED;
  props: {
    pageContextType: PageContextType;
    remediationAssignmentId?: number;
  };
} | {
  action: NewRelicAnalyticsAction.EBOOK_CFI_LINK_RESULT;
  props: {
    status: 'success' | 'no_content';
    isbn: string;
    cfi: string;
    raasAssessmentId: number;
    assessmentId: number;
    recommendationId: number;
    recommendationAttemptId: number;
  };
};
